import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import { useRole } from "components/Hooks/UserHooks";
import FeatherIcon from "feather-icons-react";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";

const Navdata = () => {
    const history = useNavigate();
    const { t } = useTranslation();
    const { userPermissions } = useRole();

    const [menuActive, setMenuActive] = useState<string>('DASHBOARD');

    // Multi Level
    const [isLevel1, setIsLevel1] = useState<boolean>(false);

    const [isCurrentState, setIsCurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
    }, [history]);

    const menuItems: any = [
        {
            id: "dashboard",
            label: t('Dashboards'),
            icon: <FeatherIcon icon="home" className="icon-dual" />,
            link: ROUTES.DASHBOARD,
            click: function (e: any) {
                setMenuActive((prev) => 'DASHBOARD');
                setIsCurrentState((prev) => 'Dashboard');
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'DASHBOARD'),
            isShow: isHavePermissionRole(ROLES_FOR_APP.DASHBOARD_VIEW, userPermissions),
            // subItems: []
        },
        {
            id: "multilevel12",
            label: t("AI News"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.AI_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "AI_NEWS");
                setIsCurrentState((prev) => "AI News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "AI_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.AI_NEWS], userPermissions),
        },
        {
            id: "multilevel5",
            label: t("Government News"),
            icon: <i className="ri-newspaper-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "GOVERNMENT_NEWS");
                setIsCurrentState((prev) => "Government News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "GOVERNMENT_NEWS",
            isShow: isHavePermissionRole(
                [
                    ROLES_FOR_APP.IMAGE_BASED_NEWS,
                    ROLES_FOR_APP.LOGO_BASED_NEWS
                ],
                userPermissions
            ),
            subItems: [
                {
                    id: "image-based-news",
                    label: t('Image Based News'),
                    link: ROUTES.IMAGE_BASED_NEWS,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.IMAGE_BASED_NEWS], userPermissions),
                },
                {
                    id: "logo-based-news",
                    label: t('Logo Based News'),
                    link: ROUTES.LOGO_BASED_NEWS,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.LOGO_BASED_NEWS], userPermissions),
                },
            ],
        },
        {
            id: "multilevel12",
            label: t("Boosting News"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.BOOSTING_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "BOOSTING_NEWS");
                setIsCurrentState((prev) => "Boosting News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "BOOSTING_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.BOOSTING_NEWS], userPermissions),
        },
        // {
        //     id: "multilevel12",
        //     label: t("Boosting Keyword"),
        //     icon: <i className="ri-flashlight-line" />,
        //     link: ROUTES.KEYWORD_BOOST_V2_LIST,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "BOOSTING_KEYWORD_V2_LIST");
        //         setIsCurrentState((prev) => "Boosting Keyword");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "BOOSTING_KEYWORD_V2_LIST",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.KEYWORD_BOOST_LIST], userPermissions),
        // },
        {
            id: "multilevel5",
            label: t("Boosting Content"),
            icon: <i className="ri-flashlight-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "BOOSTING_CONTENT");
                setIsCurrentState((prev) => "Boosting Content");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "BOOSTING_CONTENT",
            isShow: isHavePermissionRole(
                [
                    ROLES_FOR_APP.CAMPAIGN_CAR_LIST,
                    ROLES_FOR_APP.DATA_CAR_LIST,
                    ROLES_FOR_APP.CAMPAIGN_APP_TECH_LIST,
                    ROLES_FOR_APP.DATA_APP_TECH_LIST,
                    ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_LIST,
                    ROLES_FOR_APP.DATA_GOLD_PRICE_LIST,
                    ROLES_FOR_APP.CAMPAIGN_VOTE_LIST,
                    ROLES_FOR_APP.DATA_VOTE_LIST,
                    ROLES_FOR_APP.CAMPAIGN_VOTE_KEYWORD_LIST,
                    ROLES_FOR_APP.DATA_VOTE_KEYWORD_LIST
                ],
                userPermissions
            ),
            subItems: [
                {
                    id: "car",
                    label: t('Car'),
                    link: ROUTES.CAR,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.CAMPAIGN_CAR_LIST, ROLES_FOR_APP.DATA_CAR_LIST], userPermissions),
                },
                {
                    id: "app-tech",
                    label: t('AppTech'),
                    link: ROUTES.APP_TECH,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.CAMPAIGN_APP_TECH_LIST, ROLES_FOR_APP.DATA_APP_TECH_LIST], userPermissions),
                },
                {
                    id: "gold-prices",
                    label: t('Gold Prices'),
                    link: ROUTES.GOLD_PRICE,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_LIST, ROLES_FOR_APP.DATA_GOLD_PRICE_LIST], userPermissions),
                },
                {
                    id: "vote",
                    label: t('Vote'),
                    link: ROUTES.VOTE,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.CAMPAIGN_VOTE_LIST, ROLES_FOR_APP.DATA_VOTE_LIST], userPermissions),
                },
                {
                    id: "vote-keyword",
                    label: t('Vote Keyword'),
                    link: ROUTES.VOTE_KEYWORD,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.CAMPAIGN_VOTE_KEYWORD_LIST, ROLES_FOR_APP.DATA_VOTE_KEYWORD_LIST], userPermissions),
                },
                {
                    id: "news-recomposition",
                    label: t('News Recomposition'),
                    link: ROUTES.NEWS_RECOMPOSITION,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_RECOMPOSITION], userPermissions),
                },
                {
                    id: "news-travel",
                    label: t('News Travel'),
                    link: ROUTES.NEWS_TRAVEL,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_TRAVEL], userPermissions),
                },
                {
                    id: "news-weather",
                    label: t('News Weather'),
                    link: ROUTES.NEWS_WEATHER,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_WEATHER], userPermissions),
                },
                {
                    id: "news-weather-warning",
                    label: t('News Weather Warning'),
                    link: ROUTES.NEWS_WEATHER_WARNING,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_WEATHER_WARNING], userPermissions),
                },
                {
                    id: "news-stock",
                    label: t('News Stock'),
                    link: ROUTES.NEWS_STOCK,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_STOCK], userPermissions),
                },
                {
                    id: "news-toss-stock",
                    label: t('News Toss Stock'),
                    link: ROUTES.NEWS_TOSS_STOCK,
                    isShow: isHavePermissionRole([ROLES_FOR_APP.NEWS_TOSS_STOCK], userPermissions),
                },
            ],
        },
        {
            id: "multilevel12",
            label: t("Real-Time News"),
            icon: <i className="ri-newspaper-line" />,
            link: ROUTES.REAL_TIME_NEWS,
            click: function (e: any) {
                setMenuActive((prev) => "REAL_TIME_NEWS");
                setIsCurrentState((prev) => "Real-Time News");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "REAL_TIME_NEWS",
            isShow: isHavePermissionRole([ROLES_FOR_APP.REAL_TIME_NEWS], userPermissions),
        },
        // {
        //     id: "multilevel12",
        //     label: t("Real-Time Keyword"),
        //     icon: <i className="ri-flashlight-line" />,
        //     link: ROUTES.KEYWORD_REAL_TIME,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "KEYWORD_REAL_TIME");
        //         setIsCurrentState((prev) => "Real-Time Keyword");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "KEYWORD_REAL_TIME",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST], userPermissions),
        // },
        {
            id: "multilevel5",
            label: t("Keyword"),
            icon: <i className="ri-flashlight-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "KEYWORD");
                setIsCurrentState((prev) => "Keyword");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "KEYWORD",
            isShow: isHavePermissionRole(
                [
                    ROLES_FOR_APP.KEYWORD_TASK_LIST,
                    ROLES_FOR_APP.KEYWORD_BOOST_LIST,
                    ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST,
                    ROLES_FOR_APP.KEYWORD_NAVER_LIST,
                    ROLES_FOR_APP.KEYWORD_GOLDEN_LIST,
                    ROLES_FOR_APP.KEYWORD_EXCLUDE_LIST
                ],
                userPermissions
            ),
            subItems: [
                {
                    id: "task-keyword",
                    label: t('Task Keyword'),
                    link: ROUTES.KEYWORD_TASK_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_LIST, userPermissions),
                },
                {
                    id: "golden-keyword",
                    label: t('Golden Keyword'),
                    link: ROUTES.KEYWORD_GOLDEN_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_GOLDEN_LIST, userPermissions),
                },
                {
                    id: "boosting-keyword",
                    label: t('Boosting Keyword'),
                    link: ROUTES.KEYWORD_BOOST_V2_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_BOOST_LIST, userPermissions),
                },
                {
                    id: "real-time-keyword",
                    label: t('Real-Time Keyword'),
                    link: ROUTES.KEYWORD_REAL_TIME,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST, userPermissions),
                },
                {
                    id: "naver-news-keyword",
                    label: t('Naver News Keywords'),
                    link: ROUTES.KEYWORD_NAVER_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_NAVER_LIST, userPermissions),
                },

                {
                    id: "exclude-keyword",
                    label: t('Exclude Keyword'),
                    link: ROUTES.KEYWORD_EXCLUDE_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_EXCLUDE_LIST, userPermissions),
                },
            ],
        },
        {
            id: "multilevel12",
            label: t("News Monitor"),
            icon: <i className="ri-line-chart-fill" />,
            link: ROUTES.ARTICLE_TRACKING,
            click: function (e: any) {
                setMenuActive((prev) => "ARTICLE_TRACKING");
                setIsCurrentState((prev) => "News Monitor");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "ARTICLE_TRACKING",
            isShow: isHavePermissionRole([ROLES_FOR_APP.ARTICLE_TRACKING], userPermissions),
        },
        {
            id: "multilevel5",
            label: t("Statistics"),
            icon: <FeatherIcon icon="bar-chart-2" className="icon-dual" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "STATISTICS");
                setIsCurrentState((prev) => "Statistics");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "STATISTICS",
            isShow: isHavePermissionRole(
                [
                    ROLES_FOR_APP.LOG,
                    ROLES_FOR_APP.DAILY_STATISTICS,
                    ROLES_FOR_APP.HOURLY_STATISTICS,
                    ROLES_FOR_APP.KEYWORD_REAL_TIME_STATISTICS,
                    ROLES_FOR_APP.KEYWORD_PUBLISHED_STATISTICS,
                    ROLES_FOR_APP.MEDIA_STATISTICS,
                    ROLES_FOR_APP.SURVIVAL_STATISTICS
                ],
                userPermissions
            ),
            subItems: [
                {
                    id: "log",
                    label: t('Log'),
                    link: ROUTES.LOG,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.LOG, userPermissions),
                },
                {
                    id: "daily-statistics",
                    label: t('Daily Statistics'),
                    link: ROUTES.DAILY_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.DAILY_STATISTICS, userPermissions),
                },
                {
                    id: "hourly-statistics",
                    label: t('Hourly Statistics'),
                    link: ROUTES.HOURLY_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.HOURLY_STATISTICS, userPermissions),
                },
                {
                    id: "keyword-statistics-real-time",
                    label: t('Keyword Statistics (Real-time)'),
                    link: ROUTES.KEYWORD_REAL_TIME_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_STATISTICS, userPermissions),
                },
                {
                    id: "category-statistics",
                    label: t('Category Statistics'),
                    link: ROUTES.CATEGORY_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CATEGORY_STATISTICS, userPermissions),
                },
                {
                    id: "media-statistics",
                    label: t('Media Statistics'),
                    link: ROUTES.MEDIA_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.MEDIA_STATISTICS, userPermissions),
                },
                {
                    id: "keyword-statistics-published",
                    label: t('Keyword Statistics (Published)'),
                    link: ROUTES.KEYWORD_PUBLISHED_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.KEYWORD_PUBLISHED_STATISTICS, userPermissions),
                },
                {
                    id: "survival-statistics",
                    label: t('Survival Statistics'),
                    link: ROUTES.SURVIVAL_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.SURVIVAL_STATISTICS, userPermissions),
                },
                {
                    id: "approved-article-statistics",
                    label: t('Approved Article Statistics'),
                    link: ROUTES.APPROVED_ARTICLE_STATISTICS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.APPROVED_ARTICLE_STATISTICS, userPermissions),
                },
            ],
        },
        // {
        //     id: "multilevel12",
        //     label: t("Journalists"),
        //     icon: <i className="ri-user-2-line" />,
        //     link: ROUTES.JOURNALIST_LIST,
        //     click: function (e: any) {
        //         setMenuActive((prev) => "JOURNALIST_LIST");
        //         setIsCurrentState((prev) => "Journalists");
        //         updateIconSidebar(e);
        //     },
        //     stateVariables: menuActive === "JOURNALIST_LIST",
        //     isShow: isHavePermissionRole([ROLES_FOR_APP.JOURNALIST_LIST], userPermissions),
        // },
        {
            id: "multilevel12",
            label: t("User Management"),
            icon: <i className="ri-user-star-line" />,
            link: ROUTES.USER_LIST,
            click: function (e: any) {
                setMenuActive((prev) => "USER_MANAGEMENT");
                setIsCurrentState((prev) => "User Management");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "USER_MANAGEMENT",
            isShow: isHavePermissionRole([ROLES_FOR_APP.USER_LIST], userPermissions),
        },
        {
            id: "multilevel6",
            label: t("Operator Management"),
            icon: <FeatherIcon icon="users" className="icon-dual" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "USER");
                setIsCurrentState((prev) => "User");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "USER",
            isShow: isHavePermissionRole([ROLES_FOR_APP.OPERATOR_LIST, ROLES_FOR_APP.ROLE_LIST, ROLES_FOR_APP.ACTIVITY_LOG_LIST], userPermissions),
            subItems: [
                {
                    id: "user",
                    label: t("Operator"),
                    link: ROUTES.OPERATOR_LIST,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.OPERATOR_LIST,
                        userPermissions
                    ),
                },
                {
                    id: "role-list",
                    label: t("Role"),
                    link: ROUTES.OPERATOR_ROLE,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.ROLE_LIST,
                        userPermissions
                    ),
                },
                {
                    id: "activity-logs",
                    label: t("Activity Logs"),
                    link: ROUTES.OPERATOR_ACTIVITY_LOG,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.ACTIVITY_LOG_LIST,
                        userPermissions
                    ),
                },
            ],
        },
        {
            id: "multilevel6",
            label: t("Media Management"),
            icon: <FeatherIcon icon="airplay" className="icon-dual" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "MEDIA_MANAGEMENT");
                setIsCurrentState((prev) => "Media Management");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "MEDIA_MANAGEMENT",
            isShow: isHavePermissionRole([ROLES_FOR_APP.NEWSHUB_MEDIA, ROLES_FOR_APP.NEWSHUB_CAMPAIGN, ROLES_FOR_APP.NEWSHUB_NEWS], userPermissions),
            subItems: [
                {
                    id: "media",
                    label: t("Media"),
                    link: ROUTES.NEWSHUB_MEDIA,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.NEWSHUB_MEDIA,
                        userPermissions
                    ),
                },
                {
                    id: "campaign",
                    label: t("Campaign"),
                    link: ROUTES.NEWSHUB_CAMPAIGN,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.NEWSHUB_CAMPAIGN,
                        userPermissions
                    ),
                },
                {
                    id: "news",
                    label: t("News"),
                    link: ROUTES.NEWSHUB_NEWS,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.NEWSHUB_NEWS,
                        userPermissions
                    ),
                },
            ],
        },
        {
            id: "multilevel6",
            label: t("Sending Email"),
            icon: <i className="ri-mail-send-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => "SENDING_EMAIL");
                setIsCurrentState((prev) => "Sending Email");
                updateIconSidebar(e);
            },
            stateVariables: menuActive === "SENDING_EMAIL",
            isShow: isHavePermissionRole([ROLES_FOR_APP.JOURNALIST_LIST, ROLES_FOR_APP.MAIL_LOG, ROLES_FOR_APP.MAIL_STATISTICS], userPermissions),
            subItems: [
                {
                    id: "sending-email",
                    label: t("Sending Email"),
                    link: ROUTES.JOURNALIST_LIST,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.JOURNALIST_LIST,
                        userPermissions
                    ),
                },
                {
                    id: "email-statistics",
                    label: t("Email Statistics"),
                    link: ROUTES.MAIL_STATISTICS,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.MAIL_STATISTICS,
                        userPermissions
                    ),
                },
                {
                    id: "email-log",
                    label: t("Email Log"),
                    link: ROUTES.MAIL_LOG,
                    isShow: isHavePermissionRole(
                        ROLES_FOR_APP.MAIL_LOG,
                        userPermissions
                    ),
                },
            ],
        },
        {
            id: "multilevel9",
            label: t('Configuration'),
            icon: <i className="ri-settings-5-line" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'CONFIGURATION');
                setIsCurrentState((prev) => "Configuration");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'CONFIGURATION'),
            isShow: isHavePermissionRole([
                ROLES_FOR_APP.CONFIGURATION_AI_NEWS,
                ROLES_FOR_APP.CONFIGURATION_GOVERNMENT_NEWS,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS,
                ROLES_FOR_APP.CONFIGURATION_REAL_TIME_NEWS,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TRAVEL,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_STOCK,
                ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK,
                ROLES_FOR_APP.CONFIGURATION_TASK_KEYWORD,
                ROLES_FOR_APP.CONFIGURATION_REAL_KEYWORD,
                ROLES_FOR_APP.CONFIGURATION_AI_CUSTOM_NEWS,
                ROLES_FOR_APP.CONFIGURATION_REAL_TIME_KEYWORD_USER,
                ROLES_FOR_APP.CONFIGURATION_POPULAR_KEYWORD_USER,
                ROLES_FOR_APP.CONFIGURATION_APP_TECH
            ], userPermissions),
            subItems: [
                {
                    id: "ai-news",
                    label: t('AI News'),
                    link: ROUTES.CONFIGURATION_AI_NEWS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_AI_NEWS, userPermissions),
                },
                {
                    id: "government-news",
                    label: t('Government News'),
                    link: ROUTES.CONFIGURATION_GOVERNMENT_NEWS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_GOVERNMENT_NEWS, userPermissions),
                },
                {
                    id: "boosting-news",
                    label: t('Boosting News'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS, userPermissions),
                },
                {
                    id: "boosting-news-v2",
                    label: t('Boosting News v2'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_V2,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_V2, userPermissions),
                },
                {
                    id: "boosting-news-travel",
                    label: t('Boosting News Travel'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_TRAVEL,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TRAVEL, userPermissions),
                },
                {
                    id: "boosting-news-weather",
                    label: t('Boosting News Weather'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER, userPermissions),
                },
                {
                    id: "boosting-news-weather-warning",
                    label: t('Boosting News Weather Warning'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING, userPermissions),
                },
                {
                    id: "boosting-news-stock",
                    label: t('Boosting News Stock'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_STOCK,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_STOCK, userPermissions),
                },
                {
                    id: "boosting-news-toss-stock",
                    label: t('Boosting News Toss Stock'),
                    link: ROUTES.CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK, userPermissions),
                },
                {
                    id: "real-time-news",
                    label: t('Real-Time News'),
                    link: ROUTES.CONFIGURATION_REAL_TIME_NEWS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_REAL_TIME_NEWS, userPermissions),
                },
                {
                    id: "task-keyword",
                    label: t('Task Keyword'),
                    link: ROUTES.CONFIGURATION_TASK_KEYWORD,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_TASK_KEYWORD, userPermissions),
                },
                {
                    id: "real-keyword",
                    label: t('Real Time Keyword'),
                    link: ROUTES.CONFIGURATION_REAL_KEYWORD,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_REAL_KEYWORD, userPermissions),
                },
                {
                    id: "app-tech",
                    label: t('AppTech'),
                    link: ROUTES.CONFIGURATION_APP_TECH,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_APP_TECH, userPermissions),
                },
                {
                    id: "ai-article-creation-user",
                    label: t('AI Article Creation (User)'),
                    link: ROUTES.CONFIGURATION_AI_CUSTOM_NEWS,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_AI_CUSTOM_NEWS, userPermissions),
                },
                {
                    id: "real-keyword-user",
                    label: t('Real-time Keyword (User)'),
                    link: ROUTES.CONFIGURATION_REAL_TIME_KEYWORD_USER,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_REAL_TIME_KEYWORD_USER, userPermissions),
                },
                {
                    id: "popular-keyword-user",
                    label: t('Popular Keyword (User)'),
                    link: ROUTES.CONFIGURATION_POPULAR_KEYWORD_USER,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_POPULAR_KEYWORD_USER, userPermissions),
                },
            ],
        },
        {
            id: "multilevel9",
            label: t('Image Management'),
            icon: <i className="ri ri-landscape-line fs-20" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'IMAGE_MANAGEMENT');
                setIsCurrentState((prev) => "Image Management");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'IMAGE_MANAGEMENT'),
            isShow: isHavePermissionRole([
                ROLES_FOR_APP.GOOGLE_IMAGE_LIST,
                ROLES_FOR_APP.IMAGE_LIBRARY_LIST
            ], userPermissions),
            subItems: [
                {
                    id: "google-image",
                    label: t('Google Image'),
                    link: ROUTES.GOOGLE_IMAGE_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GOOGLE_IMAGE_LIST, userPermissions),
                },
                {
                    id: "custom-image",
                    label: t('Custom Image'),
                    link: ROUTES.IMAGE_LIBRARY_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.IMAGE_LIBRARY_LIST, userPermissions),
                },
                {
                    id: "public-image",
                    label: t('Public Image'),
                    link: ROUTES.IMAGE_PUBLIC_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.IMAGE_PUBLIC_LIST, userPermissions),
                },

            ],
        },
        {
            id: "multilevel9",
            label: t('Simulator'),
            icon: <i className="ri ri-profile-line fs-20" />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'SIMULATOR');
                setIsCurrentState((prev) => "Simulator");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'SIMULATOR'),
            isShow: isHavePermissionRole([
                ROLES_FOR_APP.GENERAL_NEWS_LIST,
                ROLES_FOR_APP.GENERATE_NEWS_LIST,
                ROLES_FOR_APP.GENERATE_CAR_NEWS_LIST
            ], userPermissions),
            subItems: [
                {
                    id: "general-simulator",
                    label: t('General Simulator'),
                    link: ROUTES.GENERAL_NEWS_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERAL_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-simulator",
                    label: t('News Simulator'),
                    link: ROUTES.GENERATE_NEWS_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-v2-simulator",
                    label: t('News V2 Simulator'),
                    link: ROUTES.GENERATE_NEWS_V2_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-travel-simulator",
                    label: t('Travel News Simulator'),
                    link: ROUTES.GENERATE_NEWS_TRAVEL_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-weather-simulator",
                    label: t('Weather News Simulator'),
                    link: ROUTES.GENERATE_NEWS_WEATHER_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-weather-warning-simulator",
                    label: t('Weather Warning News Simulator'),
                    link: ROUTES.GENERATE_NEWS_WEATHER_WARNING_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "news-stock-simulator",
                    label: t('Stock News Simulator'),
                    link: ROUTES.GENERATE_NEWS_STOCK_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_NEWS_LIST, userPermissions),
                },
                {
                    id: "car-simulator",
                    label: t('Car Simulator'),
                    link: ROUTES.GENERATE_CAR_NEWS_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.GENERATE_CAR_NEWS_LIST, userPermissions),
                },
            ],
        },
        {
            id: "multilevel9",
            label: t('Lab'),
            icon: <i className="ri ri-flask-line fs-20" style={{ transform: 'translateX(-1px)' }} />,
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setMenuActive((prev) => 'LAB');
                setIsCurrentState((prev) => "Lab");
                updateIconSidebar(e);
            },
            stateVariables: (menuActive === 'LAB'),
            isShow: isHavePermissionRole([
                ROLES_FOR_APP.LAB
            ], userPermissions),
            subItems: [
                {
                    id: "namuwiki-simulator",
                    label: t('Namuwiki Simulator'),
                    link: ROUTES.GENERATE_NAMUWIKI_NEWS_LIST,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.LAB, userPermissions),
                },
                {
                    id: "extract-daily-search-volume",
                    label: t('Extract Daily Search Volume'),
                    link: ROUTES.EXTRACT_DAILY_SEARCH_VOLUME,
                    isShow: isHavePermissionRole(ROLES_FOR_APP.LAB, userPermissions),
                },
                // {
                //     id: "news-travel-weather-simulator",
                //     label: t('News Travel Weather Simulator'),
                //     link: ROUTES.GENERATE_NEWS_TRAVEL_WEATHER_LIST,
                //     isShow: isHavePermissionRole(ROLES_FOR_APP.LAB, userPermissions),
                // },
                // {
                //     id: "multilevel12",
                //     label: t("Category Management"),
                //     icon: <i className="ri-flashlight-line" />,
                //     link: ROUTES.CATEGORY_LIST,
                //     click: function (e: any) {
                //         setMenuActive((prev) => "CATEGORY_LIST");
                //         setIsCurrentState((prev) => "Category Management");
                //         updateIconSidebar(e);
                //     },
                //     stateVariables: menuActive === "CATEGORY_LIST",
                //     isShow: isHavePermissionRole([ROLES_FOR_APP.CATEGORY_LIST], userPermissions),
                // },
                // {
                //     id: "multilevel12",
                //     label: t("Boosting Keywords"),
                //     icon: <i className="ri-flashlight-line" />,
                //     link: ROUTES.KEYWORD_BOOST_LIST,
                //     click: function (e: any) {
                //         setMenuActive((prev) => "BOOSTING_KEYWORD_LIST");
                //         setIsCurrentState((prev) => "Boosting Keywords");
                //         updateIconSidebar(e);
                //     },
                //     stateVariables: menuActive === "BOOSTING_KEYWORD_LIST",
                //     isShow: isHavePermissionRole([ROLES_FOR_APP.KEYWORD_BOOST_LIST], userPermissions),
                // },
            ],
        },
        // {
        //     id: "logout",
        //     label: "Logout",
        //     icon: <FeatherIcon icon="log-out" className="icon-log-out" />,
        //     link: "/logout",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIsCurrentState( (prev) =>  'Dashboard');
        //         updateIconSidebar(e);
        //     },
        // },
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
